require("./site_articleImageGallery.less")
import { ExtededImageDetails } from "../../../../../images/interfaces";
import { ArticleGalleryView } from "./articleGalleryView";
import { useEffect, useState } from "react";

interface ArticleImageGalleryDesktopProps {
    images: ExtededImageDetails[]
    articleId: string
    isLTR: boolean
}

export const ArticleImageGalleryDesktop = (props: ArticleImageGalleryDesktopProps) => {

    const { images, articleId, isLTR } = props;
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const elements = document.querySelectorAll(".gelleryOpener");

        const handleClick = (el: Element) => {
            open();

            const componentId = el.getAttribute("data-image-id")
            let indexOfMatchingImageComponentId = 0;

            for (let i = 0; i < images.length; i++) {
                if (images[i]) {
                    if (images[i].imageId === componentId) { indexOfMatchingImageComponentId = i }
                }
            }

            setCurrentImageIndex(indexOfMatchingImageComponentId);
            setIsVisible(true);
        }

        const handleKeyPress = (el: Element) => {
            const componentId = el.getAttribute("data-image-id")
            let indexOfMatchingImageComponentId = 0;

            for (let i = 0; i < images.length; i++) {
                if (images[i].componentaId === componentId) { indexOfMatchingImageComponentId = i }
            }

            setCurrentImageIndex(indexOfMatchingImageComponentId);
            setIsVisible(true);
        }

        for (let el of elements) {
            el.addEventListener("click", () => handleClick(el));
            el.addEventListener("keypress", () => handleKeyPress(el));
        }

        return () => {
            for (let el of elements) {
                el.removeEventListener("click", () => handleClick(el));
                el.removeEventListener("keypress", () => handleKeyPress(el));
            }
        }

    }, [images]);

    const swipeRight = (): void => {
        const lastImageIndex = images.length - 1
        const nextImageIndex = currentImageIndex === 0 ? lastImageIndex : currentImageIndex - 1

        analystFunc("Browse Right", articleId)
        setCurrentImageIndex(nextImageIndex);
    }

    const swipeLeft = (): void => {
        const lastImageIndex = images.length - 1
        const nextImageIndex = currentImageIndex === lastImageIndex ? 0 : currentImageIndex + 1

        analystFunc("Browse Left", articleId)
        setCurrentImageIndex(nextImageIndex);
    }

    const close = (): void => {
        document.getElementById(`image_${images[currentImageIndex].imageId}`) && document.getElementById(`image_${images[currentImageIndex].imageId}`).focus()
        analystFunc("Close Gallery", articleId)
        setIsVisible(false);
    }

    const open = (): void => {
        analystFunc("Open Gallery", articleId)
    }

    return (isVisible ?
        <ArticleGalleryView
            isLTR={isLTR}
            close={close}
            images={images}
            swipeLeft={swipeLeft}
            swipeRight={swipeRight}
            currentImageIndex={currentImageIndex}
        />
        :
        null
    )
}

ArticleImageGalleryDesktop.siteScriptName = "ArticleImageGalleryDesktop"

export const analystFunc = (action: string, articleId: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'GA_Event',
        Category: 'Photo Gallery',
        Action: action,
        Label: articleId
    });
}
